module.exports = __webpack_public_path__ + "img/Collectium-text.18020147.svg";